module.exports = __webpack_public_path__ + "img/wave.837a4296.gif";